import type { ReactNode } from "react";

interface PageHeaderProps {
  children: ReactNode;
}

export function PageHeader({ children }: PageHeaderProps) {
  return (
    <header className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between sm:gap-6">
      {children}
    </header>
  );
}

interface PageHeaderTitleProps {
  children: ReactNode;
  muted?: boolean;
}

function PageHeaderTitle({ children, muted = false }: PageHeaderTitleProps) {
  const className = muted
    ? "text-base sm:text-lg font-medium text-text-theme-secondary"
    : "text-2xl sm:text-h1 font-bold text-text-theme-primary line-clamp-2";
  return <h1 className={className}>{children}</h1>;
}

interface PageHeaderActionsProps {
  children: ReactNode;
}

function PageHeaderActions({ children }: PageHeaderActionsProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 sm:ml-auto">
      {children}
    </div>
  );
}

PageHeader.Title = PageHeaderTitle;
PageHeader.Actions = PageHeaderActions;
